import type { AppRoute } from "@/lib/routing";
import { FormulasPage } from "./pages/FormulasPage";

// Owner: C4 (formulas and compliance). Paths as in spec §9.1.
export const routes: AppRoute[] = [
  {
    path: "/formulas",
    element: <FormulasPage />,
    handle: { title: "Formulas", keywords: ["accords", "recipes", "versions", "paste formula"] },
  },
  {
    path: "/formulas/:id",
    lazy: async () => ({ Component: (await import("./pages/FormulaPage")).FormulaPage }),
    handle: { title: "Formula" },
  },
  {
    path: "/formulas/:id/compare",
    lazy: async () => ({ Component: (await import("./pages/ComparePage")).ComparePage }),
    handle: { title: "Compare versions" },
  },
  {
    path: "/formulas/:id/related",
    lazy: async () => ({ Component: (await import("./pages/RelatedPage")).RelatedPage }),
    handle: { title: "Related formulas and accords" },
  },
];
